module.exports = __webpack_public_path__ + "static/media/pimd.db8c73c7.jpeg";